export interface Company {
  id: string;
  name: string;
  email: string;
  phone?: string;
  createdAt: string;
  role: 'LSP' | 'BCO';
}

export interface InviteUserDto {
  role: 'super_admin' | 'admin' | 'user';
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: 'user' | 'admin' | 'super_admin';
  companyId: string;
  status?: string;
  createdAt: string;
}

export interface CompanyFormData {
  name: string;
  email: string;
  phone: string;
  role: string;
}

export interface UserFormData {
  name: string;
  email: string;
  role: string;
  companyId: string;
}

export const SUPPORTED_CARRIERS = ['Maersk', 'MSC', 'CMA CGM', 'ZIM', 'Hapag-Lloyd', 'COSCO'];
